import { TicketStatusTypes, TicketUrgencyTypes } from '../../domain/custom.ticket.item';

export interface ICustomTicketsWidgetsSearchRequest {
    AdminID: number;
    MemberID: number;
    IsInternal: boolean;

    StartDueDate: Date;
    EndDueDate: Date;

    StartDateTimeCreated: Date;
    EndDateTimeCreated: Date;

    CreatedByAdmin: boolean;
    Status: Array<TicketStatusTypes>;
    Urgency: Array<TicketUrgencyTypes>;
}

export class CustomTicketsWidgetsSearchRequest implements ICustomTicketsWidgetsSearchRequest {

    AdminID: number;
    MemberID: number;
    IsInternal: boolean;

    StartDueDate: Date;
    EndDueDate: Date;

    StartDateTimeCreated: Date;
    EndDateTimeCreated: Date;

    CreatedByAdmin: boolean;
    Status: Array<TicketStatusTypes>;
    Urgency: Array<TicketUrgencyTypes>;

    public constructor(fields?:
        {
            AdminID?: any,
            MemberID?: number,
            IsInternal?: boolean,
            StartDueDate?: Date,
            EndDueDate?: Date,
            StartDateTimeCreated?: Date,
            EndDateTimeCreated?: Date,
            CreatedByAdmin?: boolean,
            Status?: Array<TicketStatusTypes>,
            Urgency?: Array<TicketUrgencyTypes>,
        }) {

        if (fields)
            Object.assign(this, fields);
    }

    public static GetEmptySearch(): ICustomTicketsWidgetsSearchRequest {

        return new CustomTicketsWidgetsSearchRequest(
            {
                AdminID: null,
                MemberID: null,
                IsInternal: null,
                StartDueDate: null,
                EndDueDate: null,
                StartDateTimeCreated: null,
                EndDateTimeCreated: null,
                CreatedByAdmin: null,
                Status: null,
                Urgency: null
            });
    }

    public static GetBaseSearchForMember(memberID: number): ICustomTicketsWidgetsSearchRequest {

        return new CustomTicketsWidgetsSearchRequest(
            {
                AdminID: null,
                MemberID: memberID,
                IsInternal: null,
                StartDueDate: null,
                EndDueDate: null,
                StartDateTimeCreated: null,
                EndDateTimeCreated: null,
                CreatedByAdmin: null,
                Status: null,
                Urgency: null
            });
    }

    public static GetBaseSearchForAdmin(adminID: number): ICustomTicketsWidgetsSearchRequest {

        return new CustomTicketsWidgetsSearchRequest(
            {
                AdminID: adminID,
                MemberID: null,
                IsInternal: null,
                StartDueDate: null,
                EndDueDate: null,
                StartDateTimeCreated: null,
                EndDateTimeCreated: null,
                CreatedByAdmin: null,
                Status: null,
                Urgency: null
            });
    }

    public static GetBaseStausSearchForAdmin(adminID: number): ICustomTicketsWidgetsSearchRequest {

        let status = new Array<TicketStatusTypes>(
            TicketStatusTypes.AwaitingAdminResponse,
            TicketStatusTypes.AwaitingMemberResponse,
            TicketStatusTypes.InProgress,
            TicketStatusTypes.New);


        let request = this.GetBaseSearchForAdmin(adminID);
        request.Status = status;

        return request;
    }


    public static GetBaseStausSearchForMember(memberID: number): ICustomTicketsWidgetsSearchRequest {

        let status = new Array<TicketStatusTypes>(
            TicketStatusTypes.AwaitingAdminResponse,
            TicketStatusTypes.AwaitingMemberResponse,
            TicketStatusTypes.InProgress,
            TicketStatusTypes.New);

        let request = this.GetBaseSearchForMember(memberID);
        request.Status = status;

        return request;

    }




}
